import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import {useTranslation} from "react-i18next";

const CollectionItemActions = ({ isReserved, isLoading, isReservedMe, onCancelReserve, onReserve,
                                   onHold, isHoldedMe, isBorrowedMe, isBorrowed, onCancelHold, isHolded }) => {
    const { t } = useTranslation();

    if(!localStorage.getItem('authToken')) {
        return (
            <Button disabled={isLoading} onClick={onReserve} variant="outlined" color="primary" sx={{ marginTop: '5px', width: '250px', borderRadius: '8px' }}>
                {t('catalog.item.registerToReserve')}
            </Button>
        );
    }

    if (isReservedMe) {
        return (
            <Button disabled={isLoading} onClick={onCancelReserve} variant="outlined" color="primary" sx={{ marginTop: '5px', width: '250px', borderRadius: '8px' }}>
                {isLoading && <CircularProgress size={20} color="inherit" sx={{ marginRight: '15px' }} />}
                {t('catalog.item.cancelReservation')}
            </Button>
        );
    }

    if (isHoldedMe) {
        return (
            <Button disabled={isLoading} onClick={onCancelHold} variant="outlined" color="primary" sx={{ marginTop: '5px', width: '250px', borderRadius: '8px' }}>
                {isLoading && <CircularProgress size={20} color="inherit" sx={{ marginRight: '15px' }} />}
                {t('catalog.item.cancelHold')}
            </Button>
        );
    }

    if ((isReserved || isBorrowed) && !isHolded && !isBorrowedMe) {
        return (
            <Button disabled={isLoading} onClick={onHold} variant="outlined" color="primary" sx={{ marginTop: '5px', width: '250px', borderRadius: '8px' }}>
                {isLoading && <CircularProgress size={20} color="inherit" sx={{ marginRight: '15px' }} />}
                {t('catalog.item.confirmHold')}
            </Button>
        );
    }

    if (isReserved) {
        return (
            <>
                {/*{t('catalog.item.status.unavailable')}*/}
            </>
        );
    }

    if (isBorrowedMe || isBorrowed) {
        return <p>{t('catalog.item.checkLater')}</p>;
    }

    return (
        <Button disabled={isLoading} onClick={onReserve} variant="outlined" color="primary" sx={{ marginTop: '5px', width: '250px', borderRadius: '8px' }}>
            {isLoading && <CircularProgress size={20} color="inherit" sx={{ marginRight: '15px' }} />}
            {t('catalog.item.confirmReservation')}
        </Button>
    );
};

export default CollectionItemActions;
